import { render, staticRenderFns } from "./ctaButton.vue?vue&type=template&id=0be447d6&"
import script from "./ctaButton.vue?vue&type=script&lang=js&"
export * from "./ctaButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports